export const API_URL =
  import.meta.env.VITE_API_PREFIX || import.meta.env.REACT_APP_API_PREFIX || "https://api.curbelo-cianci.com.uy/api";

export const APP_VERSION = import.meta.env.VITE_APP_VERSION || import.meta.env.REACT_APP_VERSION || "0.0.0";

export const DEPARTMENTS = [
  { id: "ARTIGAS", name: "Artigas" },
  { id: "CANELONES", name: "Canelones" },
  { id: "CERRO_LARGO", name: "Cerro Largo" },
  { id: "COLONIA", name: "Colonia" },
  { id: "DURAZNO", name: "Durazno" },
  { id: "FLORIDA", name: "Florida" },
  { id: "FLORES", name: "Flores" },
  { id: "LAVALLEJA", name: "Lavalleja" },
  { id: "MALDONADO", name: "Maldonado" },
  { id: "MONTEVIDEO", name: "Montevideo" },
  { id: "PAYSANDU", name: "Paysandú" },
  { id: "RIO_NEGRO", name: "Río Negro" },
  { id: "RIVERA", name: "Rivera" },
  { id: "ROCHA", name: "Rocha" },
  { id: "SALTO", name: "Salto" },
  { id: "SAN_JOSE", name: "San José" },
  { id: "SORIANO", name: "Soriano" },
  { id: "TACUAREMBO", name: "Tacuarembó" },
  { id: "TREINTA_Y_TRES", name: "Treinta y Tres" },
];

/**
 * Valida que una URL sea válida (opcional)
 * @param url - La URL a validar
 * @returns Mensaje de error si la URL es inválida, undefined si es válida o vacía
 */
export const validateOptionalUrl = (url: string): string | undefined => {
  if (!url) return undefined;
  
  try {
    const urlObj = new URL(url);
    // Verificar que tenga protocolo http o https
    if (!['http:', 'https:'].includes(urlObj.protocol)) {
      return "La URL debe comenzar con http:// o https://";
    }
    return undefined;
  } catch {
    return "La URL debe ser válida (ejemplo: https://ejemplo.com)";
  }
};

/**
 * Valida que una fecha de fin sea posterior a la fecha de inicio
 * @param startDate - Fecha de inicio
 * @param endDate - Fecha de fin
 * @returns Mensaje de error si la validación falla, undefined si es válida
 */
export const validateDateRange = (
  startDate: Date | string | null | undefined,
  endDate: Date | string | null | undefined
): string | undefined => {
  if (!startDate || !endDate) return undefined;
  
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    return undefined; // Dejar que otras validaciones manejen fechas inválidas
  }
  
  if (end < start) {
    return "La fecha de fin debe ser posterior a la fecha de inicio";
  }
  
  return undefined;
};

/**
 * Valida que una fecha sea futura (no en el pasado)
 * @param date - La fecha a validar
 * @returns Mensaje de error si la fecha es en el pasado, undefined si es válida
 */
export const validateFutureDate = (
  date: Date | string | null | undefined
): string | undefined => {
  if (!date) return undefined;
  
  const dateObj = new Date(date);
  
  if (isNaN(dateObj.getTime())) {
    return undefined; // Dejar que otras validaciones manejen fechas inválidas
  }
  
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Reset time to start of day for comparison
  
  const inputDate = new Date(dateObj);
  inputDate.setHours(0, 0, 0, 0);
  
  if (inputDate < today) {
    return "La fecha no puede ser en el pasado";
  }
  
  return undefined;
};
